/**
 * Ysgithyrwyn, White-Tusk, Chief of Boars — the MVP's boss, as a body (M5-04).
 *
 * The thesis of the whole Great Hunt is written here and nowhere else: this is a
 * `quadruped`, exactly the builder the wild boar and the red stag are made with,
 * with no field the schema does not already have. He is not a boss because the
 * code knows he is one — nothing in the engine does. He is a boss because the
 * numbers on an ordinary boar are turned up until four hunters is the right
 * answer and one is a funeral, and because a hunter has walked past his kind a
 * hundred times and learned where the tusks come from.
 *
 * What "oversized" means is a distinct *species id*, so his carcass, his
 * butchery and his sign all read as him rather than as a wild boar — and heavier
 * `foreWeight` than the wild boar's, because he fights the way a boar fights only
 * more so, driving forward off the shoulders, and the shoulders are what he
 * presents to the spears. Everything else that makes him terrible is attributes
 * and armour, which is to say content, which is to say M5-06's to move.
 *
 * The weak points the ticket asks for are already in the frame the builder
 * returns and needed no special case: the eyes (`quadruped` gives every beast a
 * pair, aimable and sight-bearing), the legs (mobility, and a half-ton animal
 * that loses its legs loses the charge that is its whole fight), and the belly
 * — the `abdomen`, which his hide does not cover, reachable when he is down.
 */
import { quadruped } from './quadruped.js';
export const YSGITHYRWYN_PLAN = quadruped({
    id: 'ysgithyrwyn',
    name: 'Ysgithyrwyn',
    foreleg: 'shoulder',
    hindleg: 'ham',
    foot: 'trotter',
    // Heavier at the front than the wild boar's 1.8: he is built around the charge
    // to a degree an ordinary boar is not, and a spearman standing his ground puts
    // his point into the shoulders because that is what is coming at him.
    foreWeight: 2.2,
    // A thick, low skull carried between the shoulders. Less of him is in his head
    // than a wolf's is in its, which is the arithmetic behind "an aimed blow at the
    // eye is a level-5 problem": there is very little brain to reach and a great
    // deal of bone in the way.
    skull: 0.85,
    extras: [
        {
            id: 'tusk.left',
            zone: 'head',
            side: 'left',
            name: 'near tusk',
            hitWeight: 0.5,
            contributes: {},
            contains: ['bone'],
        },
        {
            id: 'tusk.right',
            zone: 'head',
            side: 'right',
            name: 'off tusk',
            hitWeight: 0.5,
            contributes: {},
            contains: ['bone'],
        },
    ],
});
//# sourceMappingURL=ysgithyrwyn.js.map